/* eslint-disable no-unused-vars */

/**
 * WriteRepository contract for document writes.
 * Reads can continue using Firestore SDK directly.
 */
export class WriteRepository {
  async patchDoc(path, patch, options = {}) {
    throw new Error('Not implemented');
  }

  async setDoc(path, data, options = {}) {
    throw new Error('Not implemented');
  }

  async createDoc(collectionPath, data, options = {}) {
    throw new Error('Not implemented');
  }

  async deleteDoc(path, options = {}) {
    throw new Error('Not implemented');
  }
}
